// extracted by mini-css-extract-plugin
export default {"btn":"BotaoContato_btn__jvQyX"};